import { Grid } from '@mui/material';
import * as React from 'react';
import * as Redux from 'react-redux';
import { ModalComponent } from '../../../widgets';
import { STUDENT_CONST } from '../../auth/login/LoginReducer';
import BotonComponent from '../../dashboard/components/BotonNuevo';
import {
  allUsuVistasAction,
  setActivoUsuVistasAction,
} from './UsuVistasAction';
import FormUsuVistas from './components/FormUsuVistas';
import ListadoUsuVistas from './components/ListadoUsuVistas';

const UsuVistasView = () => {
  const dispatch = Redux.useDispatch();

  const usuEntidadesStore = Redux.useSelector((state) => state.usuEntidades);
  const usuVistasStore = Redux.useSelector((state) => state.usuVistas);

  const [openModalForm, setOpenModalForm] = React.useState(false);

  const isStudent = usuEntidadesStore.activo?.usuario.rol === STUDENT_CONST;

  return (
    <Grid container spacing={1}>
      <Grid item md={12}>
        {isStudent ? null : (
          <BotonComponent
            click={async () => {
              await setActivoUsuVistasAction(dispatch, null);
              setOpenModalForm(true);
            }}
            green
            mr={2}
            text="ASIGNAR"
            addIcon
          />
        )}
        <BotonComponent
          click={async () => {
            await setActivoUsuVistasAction(dispatch, null);
            await allUsuVistasAction({ dispatch }, usuVistasStore.params);
          }}
          disabled={
            usuVistasStore.all.length === 0 || usuVistasStore.loadingAll
          }
          white
          refreshIcon
          text={usuVistasStore.loadingAll ? 'Actualizando...' : 'Actualizar'}
        />
      </Grid>
      <Grid item md={12}>
        <ListadoUsuVistas setOpenModalForm={(val) => setOpenModalForm(val)} />
      </Grid>
      <ModalComponent
        id="modalFormUsuVistas"
        maxWidth="sm"
        title={`${
          usuVistasStore.activo
            ? `Editar vista: ${usuVistasStore.activo.vista.nombre}`
            : 'Asignar vista'
        }`}
        open={openModalForm}
        onClose={() => setOpenModalForm(!openModalForm)}
      >
        <FormUsuVistas
          activo={usuVistasStore.activo}
          setOpenModalForm={(val) => setOpenModalForm(val)}
        />
      </ModalComponent>
    </Grid>
  );
};

export default UsuVistasView;
